@if (!isUniq) {
    <div checkoutCy="mixed-card-offer-{{ plan.gencode }}" class="is-centered pricing-plan">
        <div class="pricing-plan-product">
            <div class="is-3 is-radiusless plan-header no-height has-background-white">
                <checkout-card-offer-header
                    [dataEnvelope]="plan.data.data_envelope"
                    [catchyDescription]="plan.data.catchy_description"
                    [gencode]="plan.gencode"
                    [canBeLockedPlan]="plan.data.locked === '1'"
                    [isLocked]="isLocked"
                    (lockedToggleEvent)="setLocked($event)"
                    [connectionSpeed]="plan.data?.max_connection"
                />
            </div>
            <div class="plan-items">
                @if (atLeastOneOfferHasPromoHome) {
                    <div class="is-flex is-centered mb-1 promo-sticker">
                        @if (promoHome) {
                            <div class="sticker is-small is-info">{{ promoHomeWording }}</div>
                        }
                    </div>
                }
                <div class="is-3 plan-item prices-block no-height">
                    <div class="plan-price no-height has-text-centered">
                        <div class="prices-block">
                            <div class="is-main-price">
                                <checkout-prices-block
                                    [displayConnectLink]="false"
                                    [subscription]="plan"
                                    [quoteIndex]="quoteIndex"
                                    [isInlined]="false"
                                />
                            </div>
                        </div>
                        <p class="is-level-3 text is-marginless">{{ plan.data.obligation | obligationLabel }}</p>
                    </div>
                </div>
                <div class="ctas is-flex is-vertical is-justified-end">
                    @if (showAction) {
                        <div class="is-2 plan-item no-height plan-item-cta has-text-centered">
                            @if (!qty) {
                                <button
                                    checkoutCy="add-offer-{{ plan.gencode }}"
                                    class="button is-marginless is-fullwidth"
                                    (click)="add()"
                                    [ngClass]="{
                                        'is-loading': isLoading,
                                        'is-primary': cartForm.status === 'VALID',
                                        'is-conversion': cartForm.status === 'INVALID',
                                    }"
                                >
                                    Choisir ce forfait
                                </button>
                            }
                            @if (qty) {
                                <button
                                    class="button is-marginless is-fullwidth is-secondary"
                                    (click)="remove()"
                                    [ngClass]="{ 'has-actions-disabled': isLoading }"
                                >
                                    Supprimer
                                </button>
                            }
                        </div>
                    }
                    <button class="button is-marginless is-fullwidth is-secondary" (click)="displayDetails($event)">
                        En savoir plus
                    </button>
                </div>
            </div>
        </div>
    </div>
} @else {
    <div checkoutCy="mixed-card-offer-{{ plan.gencode }}">
        <div>
            <div class="plan-sticker"></div>
            <div>
                <checkout-card-offer-header
                    [dataEnvelope]="plan.data.data_envelope"
                    [catchyDescription]="plan.data.catchy_description"
                    [gencode]="plan.gencode"
                    [canBeLockedPlan]="plan.data.locked === '1'"
                    [isLocked]="isLocked"
                    (lockedToggleEvent)="setLocked($event)"
                    [atLeastOneBlockablePlan]="atLeastOneBlockablePlan"
                />
            </div>
            <div class="plan-items">
                <div class="is-3 plan-item no-height">
                    <div class="plan-price no-height">
                        <div>
                            <checkout-prices-block
                                [displayConnectLink]="false"
                                [uniqOffer]="isUniq"
                                [subscription]="plan"
                                [quoteIndex]="quoteIndex"
                            />
                        </div>
                        <p class="is-level-3 text">{{ plan.data.obligation | obligationLabel }}</p>
                    </div>
                </div>
            </div>
            <div>
                <a class="link" (click)="displayDetails($event)">En savoir plus</a>
            </div>
        </div>
    </div>
}

<ng-template #uniqOffer>
    <div checkoutCy="mixed-card-offer-{{ plan.gencode }}">
        <div>
            <div class="plan-sticker"></div>
            <div>
                <checkout-card-offer-header
                    [dataEnvelope]="plan.data.data_envelope"
                    [catchyDescription]="plan.data.catchy_description"
                    [gencode]="plan.gencode"
                    [canBeLockedPlan]="plan.data.locked === '1'"
                    [isLocked]="isLocked"
                    (lockedToggleEvent)="setLocked($event)"
                />
            </div>
            <div class="plan-items">
                <div class="is-3 plan-item no-height">
                    <div class="plan-price no-height">
                        <div>
                            <div>
                                <checkout-prices-block
                                    [displayConnectLink]="false"
                                    [uniqOffer]="isUniq"
                                    [subscription]="plan"
                                    [quoteIndex]="quoteIndex"
                                ></checkout-prices-block>
                            </div>
                        </div>
                        <p class="is-level-3 text">{{ plan.data.obligation | obligationLabel }}</p>
                    </div>
                </div>
            </div>
            <div>
                <a class="link" (click)="displayDetails($event)">En savoir plus</a>
            </div>
        </div>
    </div>
</ng-template>
